let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hvqFq")).then(() => parcelRequire('5H92h'));